import React, { useState, useEffect } from 'react';
import NavBars from '../Sidebar/Sidebar';
import './protected.css';
import { UserAuth } from "../../authContext";
import { db } from '../../firebase'; // Adjust this path based on your project structure
import { collection, addDoc, query, where, getDocs } from 'firebase/firestore';
import { useNavigate } from "react-router-dom";
const ProjReq = () => {
    const navigate = useNavigate();
    const { user } = UserAuth();
    const [formData, setFormData] = useState({
        productName: '',
        productLink: '',
        imageLink: '',
        quantity: 0,
        description: '',
    });
    const [pendingRequests, setPendingRequests] = useState([]);
    const [count, setCount] = useState(0);
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(0);
    const [selectedItem, setSelectedItem] = useState(null);

    // Update the items based on the quantity
    const handlePageChange = (e) => {
        const value = parseInt(e.target.value, 10) || 0;
        setFormData((prev) => ({
            ...prev,
            quantity: value, // Update quantity
        }));

        // Create a new items array based on the new quantity
        setItems(Array.from({ length: value }, (_, i) => ({
            id: i,
            productName: `Item ${i + 1}`,
            quantity: 1,
        })));
    };

    const openModal = (item) => {
        setSelectedItem({ ...item }); // Create a copy to avoid direct state mutation
    };

    const closeModal = () => {
        // Save changes to the items list
        setItems(prevItems =>
            prevItems.map(item => item.id === selectedItem.id ? selectedItem : item)
        );
        setSelectedItem(null);
    };

    const handleModalChange = (e) => {
        const { name, value } = e.target;
        setSelectedItem(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Validate form and items before submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Validate form fields
        if (!formData.productName || !formData.description || formData.quantity <= 0) {
            alert("Please fill in all required fields with valid values.");
            return;
        }
    
        // Validate item fields
        for (const item of items) {
            if (!item.productName || item.quantity <= 0) {
                alert(`Please fill in all fields for item: ${item.productName || "Unnamed Item"}`);
                return;
            }
        }
    
        try {
            // Prepare the request data
            const purchaseRequestData = {
                projectTitle: formData.productName,
                description: formData.description,
                quantity: formData.quantity,
                items: items, // Array of items to be sent
                userId: user?.uid,
                userEmail: user?.email,
                timestamp: new Date(),
            };
    
            // Submit the data to Firebase (adjust the collection name as needed)
            await addDoc(collection(db, "projectRequests"), purchaseRequestData);
    
            // Show success message
            alert("Project Proposal Request submitted successfully!");
    
            // Reset form and items
            setFormData({
                productName: "",
                productLink: "",
                imageLink: "",
                quantity: 0,
                description: "",
            });
            setItems([]);
    
            // Navigate to /projects
            navigate("/projects");
        } catch (error) {
            console.error("Error submitting project request:", error);
            alert("Failed to submit project request. Please try again.");
        }
    };
    

    return (
        <div className="request-page">
            <div className="content">
                <h1 className='request-header'>Project Proposal Request Form</h1>
                <form className='request-form' onSubmit={handleSubmit}>
                    <div className="request-form-grid">
                        <div className="request-form-group">
                            <label htmlFor="productName" className='request-label'>Project Title</label>
                            <input 
                                type="text" 
                                required 
                                name="productName" 
                                className='request-input' 
                                value={formData.productName} 
                                onChange={(e) => setFormData({ ...formData, productName: e.target.value })} 
                            />
                        </div>
                        
                        <div className="request-form-group">
                            <label htmlFor="quantity" className='request-label'>Number of Parts</label>
                            <input 
                                type="number" 
                                required 
                                className='request-input' 
                                min="0" 
                                name="quantity" 
                                value={formData.quantity} 
                                onChange={handlePageChange} 
                            />
                        </div>

                        <div className="request-form-group">
                            <label htmlFor="description" className='request-label'>Description</label>
                            <textarea 
                                name="description" 
                                value={formData.description} 
                                onChange={(e) => setFormData({ ...formData, description: e.target.value })} 
                                className='request-textarea' 
                            />
                        </div>
                    </div>
                    <div>Edit these items by clicking on them</div>
                    <div 
    className="grid-container" 
    style={{
        display: 'flex',
        overflow: 'visable',
        overflowX: 'auto',
        padding: '10px',
        gap: '10px',
        scrollbarWidth: 'thin',  // For Firefox
        // Removed fixed height, allowing it to fit the content dynamically
    }}
                >
                    {items.map(item => (
                        <div 
                            key={item.id} 
                            className='item' 
                            onClick={() => openModal(item)} 
                            style={{
                                flexShrink: 0,  // Prevent items from shrinking
                                padding: '5px',  // Reduced padding for a smaller size
                                backgroundColor: '#f1f1f1',
                                borderRadius: '5px',
                                border: '1px solid #ddd',
                                cursor: 'pointer',
                                minWidth: '150px',  // Set a minimum width for each item
                                textAlign: 'center',  // Center text
                                height: '100px',  // Reduced height for the item
                                lineHeight: '50px',  // Vertically center text
                            }}
                        >
                            <p>{item.productName}</p>
                            <p>Quantity: {item.quantity}</p>
                        </div>
                    ))}
                </div>
                    <button type="submit" className='request-button'>Submit</button>
                </form>

                
            </div>
            <NavBars />

            {selectedItem && (
                <div className="modal">
                    <div className="modal-content">
                        <h2>Edit Item</h2>
                        <label>Product Name</label>
                        <input 
                            type="text" 
                            name="productName" 
                            value={selectedItem.productName} 
                            onChange={handleModalChange} 
                        />
                        <label>Product Link (Optional)</label>
                        <input 
                            type="text" 
                            name="productLink" 
                            value={selectedItem.productLink || ''} 
                            onChange={handleModalChange} 
                        />
                        <label>Image Link</label>
                        <input 
                            type="text" 
                            name="imageLink" 
                            value={selectedItem.imageLink || ''} 
                            onChange={handleModalChange} 
                        />
                        <label>Quantity</label>
                        <input 
                            type="number" 
                            name="quantity" 
                            value={selectedItem.quantity} 
                            min="1" 
                            onChange={handleModalChange} 
                        />
                        <label>Specifications</label>
                        <textarea 
                            name="specifications" 
                            value={selectedItem.specifications || ''} 
                            onChange={handleModalChange}
                        ></textarea>
                        <button onClick={closeModal}>Close</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProjReq;
